import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const DeleteDealPlanModalComponent = ({
  isShared,
  isDeleting,
  onConfirm,
  onClose
}) => {
  return /*#__PURE__*/_jsx(ConfirmModal, {
    width: 512,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dealPlan.deleteDealPlan.confirmTitle"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: isShared ? 'dealPlan.deleteDealPlan.confirmDescriptionShared' : 'dealPlan.deleteDealPlan.confirmDescriptionUnshared'
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dealPlan.deleteDealPlan.confirmDelete"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dealPlan.deleteDealPlan.confirmCancel"
    }),
    onConfirm: onConfirm,
    onReject: onClose,
    confirmUse: "danger",
    rejectUse: "primary-white",
    confirmButtonProps: {
      loading: isDeleting
    },
    rejectButtonProps: {
      borderColor: 'border-core-default',
      style: {
        marginLeft: 'auto'
      }
    }
  });
};